import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../store/thunks/authThunks';
import { forgotPassword } from '../../services/user';
import swal from 'sweetalert';

const Login = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
      });

    const [showModal, setShowModal] = useState(false);
    const [email, setEmail] = useState('');
      
      const { loading, error } = useSelector(state => state.auth);
      const dispatch = useDispatch();
      
      const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value,
        });
      };
      
      const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(login(formData));
      };

      const closeModal = () => {
        setShowModal(false);
      };

      const handleChangePass = (e) => {
        setEmail(e.target.value);
      }

      const sendPassword = async () => {
        await forgotPassword({email})
        .then(resp=>{
          console.log(resp)
          closeModal();
          swal({
              title: "Forgot Password",
              text: resp?.data?.message,
              icon: "success",
              buttons: true,
            });
        })
        .catch(error=>{
          console.log(error);
          swal({
                title: "Forgot Password",
                text: error?.response?.data?.error,
                icon: "error",
                buttons: true,
              });
        });
      }
      
      return (
        <>
          {loading && (
          <div className="absolute inset-0 bg-white-transparents flex items-center justify-center z-50">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500"></div>
          </div>
          )}
          <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
                Sign in to your account
              </h2>            
            </div>
          
            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
              <div className="bg-white dark:bg-gray-800 py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form className="space-y-6" onSubmit={handleSubmit}>
                  {error && (
                    <div className="bg-red-50 dark:bg-red-900/30 border-l-4 border-red-500 p-4">
                      <p className="text-sm text-red-700 dark:text-red-400">{error}</p>
                    </div>
                  )}

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                      Email address
                    </label>
                    <div className="mt-1">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm dark:bg-gray-700 dark:text-white"
                      />
                    </div>
                  </div>
                
                  <div>
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                      Password
                    </label>
                    <div className="mt-1">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        autoComplete="current-password"
                        required
                        value={formData.password}
                        onChange={handleChange}
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm dark:bg-gray-700 dark:text-white"
                      />
                    </div>
                  </div>
                
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                    </div>
                
                    {/* <div className="text-sm">
                      <a href="#" className="font-medium text-blue-600 hover:text-blue-500" onClick={(e)=> setShowModal(!showModal)}>
                        Forgot your password?
                      </a>
                    </div> */}
                  </div>
                
                  <div>
                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 cursor-pointer"
                    >
                      {loading ? 'Signing in...' : 'Sign in'}
                    </button>
                  </div>
                </form>
                
                <div className="mt-6">
                  {/* <div className="relative">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t border-gray-300 dark:border-gray-600"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="px-2 bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400">
                        Demo Accounts
                      </span>
                    </div>
                  </div> */}
                
                  <div className="mt-6 grid grid-cols-1 gap-3">
                    {/* <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-md text-sm">
                      <p className="font-medium text-gray-800 dark:text-gray-200">Super Admin:</p>
                      <p className="text-gray-600 dark:text-gray-300">Email: superadmin@example.com</p>
                      <p className="text-gray-600 dark:text-gray-300">Password: password</p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

            {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Forgot Password</h2>
              <button
                className="text-gray-600 hover:text-gray-800 cursor-pointer"
                onClick={closeModal}
              >
                ✕
              </button>
            </div>

              <div className="mb-4">
                      <label className="block text-sm font-medium mb-1">Email*</label>
                      <input
                        type="text"
                        className="w-full border border-gray-300 px-3 py-2 rounded"
                        placeholder="Enter email"
                        name="user_email"
                        value={email}
                        onChange={handleChangePass}
                      />
                    </div>
                    {/* Add more form fields here if needed */}

                    <div className="text-right">
                      <button
                        type="button"
                        onClick={closeModal}
                        className="bg-gray-100 text-gray-800 px-4 py-2 rounded mr-2 cursor-pointer"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 cursor-pointer"
                        onClick={sendPassword}
                      >
                        Send
                      </button>
                    </div>
                </div>
              </div>
            )}
        </>
      );
}

export default Login
